export default "__VITE_ASSET__CEg5VWjM__"